<div class="snakebar">
  <div class="lead"> VNPT-ASXH </div><br/>
  <div class="data" [innerHTML]="data.ms"> </div>
  <div class="dismiss">
    <button mat-icon-button (click)="snackBarRef.dismiss()">
      <mat-icon> close </mat-icon>
    </button>
  </div>
</div>
